import { JWTService } from '@services/jwt.service';
import { LocationsApiService } from '@services/locations.api.service';

import { SET_LOCATIONS, SET_SUFFIX, GET_LOCATIONS } from './locations.types';

export default {
  namespaced: true,

  state: {
    locations: JSON.parse(JWTService.getLocations()),
    suffix: JWTService.getLocationSuffix(),
  },

  mutations: {
    [SET_LOCATIONS](state, payload) {
      JWTService.setLocations(JSON.stringify(payload));
      state.locations = payload;
    },
    [SET_SUFFIX](state, payload) {
      JWTService.setLocationSuffix(payload);
      state.suffix = payload;
    },
  },

  actions: {
    async [GET_LOCATIONS](
      { commit, state: { suffix: currentSuffix } },
      { suffix } = {},
    ) {
      const data = await LocationsApiService.getLocations();
      const currentLocation = suffix || currentSuffix;
      const [firstLocationData = {}] = data;
      const filteredLocationData = data
        .find(location => location.suffix === currentLocation) || {};

      commit(SET_LOCATIONS, data);
      commit(SET_SUFFIX, filteredLocationData.suffix || firstLocationData.suffix || '');
    },
  },
};
